import { RcDialerPadSoundsMPEG } from '@ringcentral/juno';

export default RcDialerPadSoundsMPEG;
